import { Component, OnInit, ViewChild } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { identificationService } from '@unpispas/upp-base';
import { appBootstrap } from '@unpispas/upp-base';
import { viewService } from '@unpispas/upp-base';
import { loginService } from '@unpispas/upp-data';

import { UppLoginPageComponent, type LoginCredentials } from '../login-page/upp-login';

type ViewPage = 'LOGIN' | 'RECOVERY' | 'REGISTRY';

@Component({
    selector: 'upp-login',
    templateUrl: './upp-login.html',
    styleUrls: [
      './upp-login.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UppLoginComponent implements OnInit {
    @ViewChild(UppLoginPageComponent) private loginPage?: UppLoginPageComponent;

    constructor(
        private route: ActivatedRoute,
        private device: identificationService,
        private login: loginService,
        public view: viewService
    ){
        // nothing to do
    }

    async ngOnInit(): Promise <void> {
        try {
            if ((await this.device.IsKnown())){
                console.info("[LOGIN] Attempting token login..")

                const _token = this.route.snapshot.queryParamMap.get("token");
                if (_token && await this.login.DoToken(_token)){
                    console.info("[LOGIN] Recovered login information from session token");
                    return;
                }

                console.info("[LOGIN] Attempting stored login..")
                if (await this.login.DoStored()){
                    console.info("[LOGIN] Recovered login information from storage");
                    return;
                }

                console.info("[LOGIN] Login information is required.")
            }
            else {
                console.info("[LOGIN] Terminal not registered — manual login required.");
            }
        }
        finally {
            // Boot/login flow concluded: the resulting screen (login form or auto-login
            // target view) can now be shown, so the splash screen may be cleared.
            setTimeout(() => {
                appBootstrap.MarkReady();
            }, 500);
        }
    }

    private _page: ViewPage = 'LOGIN';
    get Page(): ViewPage {
        return this._page;
    }

    set Page(value: ViewPage){
        this._page = value;
    }

    OpenLogin(credentials: LoginCredentials | null = null){
        this.Page = 'LOGIN';
        if (credentials){
            this.loginPage?.SetCredentials(credentials);
        }
    }

    OpenRecovery(){
        this.Page = 'RECOVERY';
    }

    OpenRegistry(){
        this.Page = 'REGISTRY';
    }
}
